import * as React from 'react';
import { useDrawerDirection, Drawer } from '@grandvisionhq/common';

const ProductDetailDrawer = ({ title , ctaButton , children , 'data-t': dataT , shouldMountContent ,  })=>{
    const drawerDirection = useDrawerDirection();
    const isRightDirection = drawerDirection === 'right';
    const Title = /*#__PURE__*/ React.createElement(Drawer.Title, null, title);
    return /*#__PURE__*/ React.createElement(Drawer, {
        direction: drawerDirection
    }, ctaButton, /*#__PURE__*/ React.createElement(Drawer.Backdrop, null), /*#__PURE__*/ React.createElement(Drawer.Overlay, {
        "data-t": dataT,
        shouldMountContent: shouldMountContent
    }, /*#__PURE__*/ React.createElement(Drawer.Header, {
        LeftSlot: !isRightDirection && Title,
        RightSlot: /*#__PURE__*/ React.createElement(Drawer.CloseButton, null)
    }), !isRightDirection && /*#__PURE__*/ React.createElement(Drawer.Divider, null), /*#__PURE__*/ React.createElement(Drawer.Content, null, isRightDirection && Title, children)));
};

export { ProductDetailDrawer };
//# sourceMappingURL=ProductDetailDrawer.js.map
